import React, { useState } from "react";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import CommonTable from "../../components/Table/CommonTable";
import CommonFilters from "../../components/Filters/CommonFilters";
import StageModal from "../../Modal/Stages/StageModal";
import useStages from "../../Hooks/useStages";
import { Button, Badge } from "reactstrap";

const StagesList = () => {
  const [filters, setFilters] = useState({
    search: "",
    page: 1,
  });

  const [modal, setModal] = useState(false);
  const [mode, setMode] = useState("create");
  const [selectedStage, setSelectedStage] = useState(null);

  const { stages, loading, pagination, fetchStages, createStage, updateStage, toggleStage } =
    useStages(filters);

  const columns = [
    {
      header: "Sort Order",
      render: (row) => (
        <Badge color="primary" pill className="px-3 py-2 fs-6">
          #{row.sort_order ?? 0}
        </Badge>
      ),
    },
    { header: "Name", accessor: "name" },
    {
      header: "Status",
      render: (row) => (
        <Badge color={row.isActive ? "success" : "secondary"} pill className="px-3 py-2">
          {row.isActive ? "Active" : "Inactive"}
        </Badge>
      ),
    },
  ];

  const filtersConfig = [
    {
      type: "search",
      name: "search",
      placeholder: "Search stage...",
      col: 3,
    },
  ];

  return (
    <div className="page-content">
      <Breadcrumbs title="Stages" breadcrumbItem="Manage Stages" />

      <CommonFilters
        config={filtersConfig}
        filters={filters}
        setFilters={(updater) =>
          setFilters((prev) => ({
            ...prev,
            ...(typeof updater === "function" ? updater(prev) : updater),
            page: 1,
          }))
        }
        onSearch={fetchStages}
        onReset={() =>
          setFilters({ search: "", page: 1 })
        }
        onAdd={() => {
          setMode("create");
          setSelectedStage(null);
          setModal(true);
        }}
        actions={{
          showSearchBtn: true,
          showResetBtn: true,
          showAddBtn: true,
          addBtnText: "Add Stage",
        }}
      />

      <CommonTable
        columns={columns}
        data={stages}
        loading={loading}
        onEdit={(row) => {
          setMode("edit");
          setSelectedStage(row);
          setModal(true);
        }}
        onToggle={(row) => toggleStage(row._id)}
      />

      {/* PAGINATION */}
      <div className="d-flex justify-content-end align-items-center mt-3 gap-3">
        <Button
          color="light"
          disabled={pagination.page <= 1}
          onClick={() =>
            setFilters((prev) => ({
              ...prev,
              page: prev.page - 1,
            }))
          }
        >
          <i className="mdi mdi-chevron-left me-1" />
          Prev
        </Button>

        <span className="fw-semibold">
          Page {pagination.page} of {pagination.totalPages}
        </span>

        <Button
          color="light"
          disabled={pagination.page >= pagination.totalPages}
          onClick={() =>
            setFilters((prev) => ({
              ...prev,
              page: prev.page + 1,
            }))
          }
        >
          Next
          <i className="mdi mdi-chevron-right ms-1" />
        </Button>
      </div>

      <StageModal
        isOpen={modal}
        toggle={() => setModal(false)}
        mode={mode}
        selectedStage={selectedStage}
        onSuccess={() => fetchStages()}
        createStage={createStage}
        updateStage={updateStage}
      />
    </div>
  );
};

export default StagesList;